/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../plugins/vant-demand-import/installComponents.js"
import VanCheckbox from 'vant/es/checkbox'
import 'vant/es/checkbox/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/checkbox.css'


import { render, staticRenderFns } from "./register-privacy-checkbox.vue.js?vue&type=template&id=ecadb65e!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-checkbox.vue?vue&type=template&id=ecadb65e"
import script from "./register-privacy-checkbox.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./register-privacy-checkbox.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-checkbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./register-privacy-checkbox.vue.postcss?vue&type=style&index=0&id=ecadb65e&prod&lang=postcss&module=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-privacy-checkbox.vue?vue&type=style&index=0&id=ecadb65e&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanCheckbox})
